export default __webpack_public_path__ + "d237e2ad60cd2189d66c5cd28f710ad4.svg";